import React from 'react';
import { Colors } from '../../assets/theme/Colors';

// Mui v5 -> uses class names created in GlobalStyles at BaseMUIDataTable.jsx
export const useRescuesTableRowColorStyles = () => ({
  closedRescueRow: 'closedRescueRow',
  cancelledRescueRow: 'cancelledRescueRow',
  unclaimedRescueRow: 'unclaimedRescueRow',
  claimedRescueRow: 'claimedRescueRow',
});

const RescuesTableStatusBox = ({ rescue }) => {
  if (rescue && rescue.cancelled_by_id) {
    return (
      <>
        <br />
        <span style={{ color: Colors.rescues.cancelled.color, fontWeight: 'bold' }}>Cancelled</span>
      </>
    );
  }

  if (rescue && rescue.closed_by_id) {
    return (
      <>
        <br />
        <span style={{ color: Colors.rescues.closed.color, fontWeight: 'bold' }}>Closed</span>
      </>
    );
  }

  if (rescue && rescue.claimer) {
    return (
      <>
        <br />
        <span style={{ color: Colors.rescues.claimed.color, fontWeight: 'bold' }}>Claimed</span>
      </>
    );
  }
  if (rescue && !rescue.claimer) {
    return (
      <>
        <br />
        <span style={{ color: Colors.rescues.unclaimed.color, fontWeight: 'bold' }}>Unclaimed</span>
      </>
    );
  }

  return null;
};

export default RescuesTableStatusBox;
